import type { Sound } from "../sounds/sounds";
import { isRinging, type CallStage } from "./call-state";

type Player = { play: (sound: Sound) => boolean; stop: () => void };

// Sound follows actual media transitions, independently of query refreshes.
export class CallSounds {
  private call: CallStage | null = null;
  private timer: ReturnType<typeof setTimeout> | null = null;
  private connected = false;
  private warned = false;
  private player: Player;
  constructor(player: Player) {
    this.player = player;
  }

  private stop() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    this.player.stop();
  }
  reset() {
    this.stop();
    this.call = null;
    this.connected = this.warned = false;
  }
  ring = () => {
    if (!isRinging(this.call)) return;
    const incoming = this.call?.status === "incoming";
    this.player.play(incoming ? "incoming" : "outgoing");
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(this.ring, incoming ? 3000 : 4000);
  };
  update(value: CallStage | null) {
    const next = value?.id ? value : null;
    const previous = this.call;
    if (previous?.id === next?.id && previous?.status === next?.status) return;
    this.stop();
    this.call = next;
    if (!next) {
      if (previous) this.player.play("ended");
      this.connected = this.warned = false;
      return;
    }
    if (previous?.id !== next.id) this.connected = this.warned = false;
    if (isRinging(next)) this.ring();
    if (next.status === "connected") {
      if (!this.connected) this.player.play("connected");
      else if (this.warned) this.player.play("restored");
      this.connected = true;
      this.warned = false;
    }
    if (next.status === "reconnecting" && this.connected)
      this.timer = setTimeout(() => {
        this.timer = null;
        this.warned = this.player.play("reconnecting");
      }, 2500);
  }
}
